import script from "./AppMenuTopBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMenuTopBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppMenuTopBar.vue?vue&type=style&index=0&id=3c195752&lang=scss&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c195752"]])

export default __exports__